import parse from 'html-react-parser';
import { Heading } from '@hungryroot/ramen';
import styles from './CookingInstructions.module.css';

interface Props {
  testid?: string;
  instructions: string;
}

export default function CookingInstructions(props: Props) {
  const { testid, instructions } = props;

  return (
    <section data-testid={testid} className={styles.section}>
      <Heading className={styles.heading} variant="H5">
        Instructions
      </Heading>
      <h3
        data-testid={`${testid}-content`}
        className={styles['instructions-text']}
      >
        {parse(instructions)}
      </h3>
    </section>
  );
}
